
<div class ="row orders_sideRight">
  <div class="col-xs-12 col-md-6 orders_latesshipment">{{"ordersummary.orderoverview" | cxTranslate}}</div>
  @if ( dataSource && dataSource.length != 0) {
    <div class="col-xs-12 col-md-6 d-none d-sm-none d-md-none d-lg-block orders_vieworder orders_vieworder_heading">
      <a class="orders_viewalltxt anchorunderline" [routerLink]="'/orders/my-orders'">{{"ordersummary.viewopenorders" | cxTranslate}}<i class="global_blackarrow"></i></a>
    </div>
  }
  <div class="col-xs-12 overview_info">{{"ordersummary.overviewmsg" | cxTranslate}}</div>
  @if (dataSource && dataSource.length != 0) {
    <div class="col-xs-12 col-md-6 d-block d-sm-block d-md-block d-lg-none orders_vieworder">
      <a class="orders_viewalltxt anchorunderline" [routerLink]="'/orders/my-orders'">{{"ordersummary.viewopenorders" | cxTranslate}}<i class="global_blackarrow"></i></a>
    </div>
  }
  <div class="col-xs-12 d-none d-sm-none d-md-none d-lg-block margin-T30 overview_table">
    @if ( dataSource && dataSource.length != 0) {
      <table class="tableClass" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef> {{"ordersummary.shiploclabel" | cxTranslate}} </th>
          <td mat-cell class="matRow" *matCellDef="let element"> {{element.address}} </td>
        </ng-container>
        <ng-container matColumnDef="deliveredQty">
          <th mat-header-cell *matHeaderCellDef> {{"ordersummary.qtydeliveredlabel" | cxTranslate}} </th>
          <td mat-cell class="matRow" *matCellDef="let element"><span class="unitsClass">{{element.deliveredQty | number:'1.0'}} units / {{element.totalQty | number:'1.0'}} total</span><mat-progress-bar mode="determinate" value= {{getProgress(element.deliveredQty,element.totalQty)}}></mat-progress-bar></td>
        </ng-container>
        <ng-container matColumnDef="orderNum">
          <th mat-header-cell *matHeaderCellDef>{{"ordersummary.orderlabel" | cxTranslate}}</th>
          <td mat-cell class="matRow" *matCellDef="let element"><a class="orders_viewDetails anchorunderline" [routerLink]="'/orders/my-orders'" [queryParams]="{address: element.address,season:inseason}">{{"ordersummary.vieworderlabel" | cxTranslate}}  <i class="global_blackarrow"></i></a> </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }

    @if ( dataSource?.length>=10) {
      <div class="col-xs-12 col-md-6  table_viewOrders">
        <a [routerLink]="'/orders/my-orders'" class="orders_viewalltxt anchorunderline orders_vieworder_link">{{"ordersummary.viewopenorders" | cxTranslate}}<i class="global_blackarrow"></i>
      </a>
    </div>
  }
</div>
<div class="col-xs-12 d-block d-sm-block d-md-block d-lg-none overview_table" >
  @if ( dataSource && dataSource.length != 0) {
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="combined">
        <th class="odertableheader" mat-header-cell *matHeaderCellDef></th>
        <td mat-cell class="matRow" *matCellDef="let element">
          <div class="orders_mobileVisible">{{"ordersummary.shiploclabel" | cxTranslate}} </div>
          <div class="addressClass">{{element.address}} </div>
          <div class="orders_mobileVisible">{{"ordersummary.qtydeliveredlabel" | cxTranslate}}</div>
          <div class="progressClass">{{element.deliveredQty | number:'1.0'}} units / {{element.totalQty | number:'1.0'}} total<mat-progress-bar mode="determinate" value= {{getProgress(element.deliveredQty,element.totalQty)}}></mat-progress-bar></div>
          <div class="orders_mobileVisible">{{"ordersummary.orderlabel" | cxTranslate}}</div>
          <div class="viewOrderClass"><a class="orders_viewDetails anchorunderline" [routerLink]="'/orders/my-orders'" [queryParams]="{address: element.address}">{{"ordersummary.vieworderlabel" | cxTranslate}} <i class="global_blackarrow"></i></a></div>
        </td>
      </ng-container>
      <tr  mat-header-row *matHeaderRowDef="displayedColumnsMobile"></tr>
      <tr  mat-row *matRowDef="let row; columns: displayedColumnsMobile;"></tr>
    </table>
  }
  @if ( dataSource?.length>=10) {
    <div class="col-xs-12 col-md-6  table_viewOrders">
      <a [routerLink]="'/orders/my-orders'" class="orders_viewalltxt anchorunderline">{{"ordersummary.viewopenorders" | cxTranslate}}<i class="global_blackarrow"></i>
    </a>
  </div>
}
</div>
@if ( dataSource && dataSource?.length == 0) {
  <div class="col-xs-12 overview_orders" appRouterlinkinterceptor [innerHTML]="'ordersummary.noOrdersmsg' | cxTranslate" >
  </div>
}
</div>

@if (isLoading) {
  <div class="loading">
    <div class="loading_txt">
      <div class="load_txt">{{"ordersummary.loadinglabel" | cxTranslate}}</div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
